<script lang="ts">
    import {guiCreatorDataStore} from '../../stores/guiCreatorData';
    import {UIButton} from './button';
    import ConfigInput from "../utils/ConfigTextInput.svelte";
    import {UIElement} from '../element';
    import {OriginCoords} from '../../types';
    import ConfigCheckbox from "../utils/ConfigCheckbox.svelte";
    import {isStringColorString} from "../../utils/helpers";

    export let uiElement: UIButton;
    export let origin: OriginCoords;

    let nameValue = uiElement.name;
    let xValue = uiElement.x.toString();
    let yValue = uiElement.y.toString();
    let widthValue = uiElement.width.toString();
    let heightValue = uiElement.height.toString();
    let backgroundColor = uiElement.backgroundColor;
    let textColor = uiElement.textColor;
    let textValue = uiElement.text;
    let fontSizeValue = uiElement.fontSize;
    let showHitBoxValue = uiElement.showHitBox;
    let vibrateValue = uiElement.vibrate;
    let hitBoxOffsetXLeftValue = uiElement.hitBoxOffsetXLeft;
    let hitBoxOffsetXRightValue = uiElement.hitBoxOffsetXRight;
    let hitBoxOffsetYTopValue = uiElement.hitBoxOffsetYTop;
    let hitBoxOffsetYBottomValue = uiElement.hitBoxOffsetYBottom;
    let groupValue = uiElement.group;
    let zValue = uiElement.z;

    function onValueChange(attributeName: keyof UIButton | keyof UIElement, parseValueToInt = true) {
        return (value) => {
            uiElement[attributeName] = parseValueToInt ? parseInt(value.detail) : value.detail;
            guiCreatorDataStore.update(uiElement);
        }
    }


</script>

<div>

    <div class="flex flex-row bg-center pt-1">
        <p class="text-lg">Infos: Button</p>
    </div>

    <ConfigInput value="{nameValue}" on:configValueChanged={onValueChange('name', false)} title="Name"></ConfigInput>
    <ConfigInput value="{groupValue || ''}" on:configValueChanged={onValueChange('group', false)}
                 title="Group"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Text</p>
    </div>
    <ConfigInput value="{textValue}" on:configValueChanged={onValueChange('text', false)} title="Text"></ConfigInput>
    <ConfigInput value="{fontSizeValue}" on:configValueChanged={onValueChange('fontSize', false)}
                 title="Font Size"></ConfigInput>

    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Position</p>
    </div>
    <ConfigInput value="{xValue}" on:configValueChanged={onValueChange('x', true)}
                 title="X"></ConfigInput>
    <ConfigInput value="{yValue}" on:configValueChanged={onValueChange('y', true)}
                 title="Y"></ConfigInput>
    <ConfigInput value="{zValue}" on:configValueChanged={onValueChange('z', true)}
                 title="Z"></ConfigInput>

    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Measurements</p>
    </div>
    <ConfigInput value="{widthValue}" on:configValueChanged={onValueChange('width', true)} title="Width"></ConfigInput>
    <ConfigInput value="{heightValue}" on:configValueChanged={onValueChange('height', true)}
                 title="Height"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Look</p>
    </div>
    <ConfigInput value="{backgroundColor}" validator="{isStringColorString}"
                 on:configValueChanged={onValueChange('backgroundColor', false)}
                 title="Color"></ConfigInput>
    <ConfigInput value="{textColor}" validator="{isStringColorString}"
                 on:configValueChanged={onValueChange('textColor', false)} title="Text color"></ConfigInput>

    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Hitbox</p>
    </div>
    <ConfigCheckbox value="{showHitBoxValue}" title="Show hit box"
                    on:configValueChanged={onValueChange('showHitBox', false)}></ConfigCheckbox>
    <ConfigInput value="{hitBoxOffsetXLeftValue}"
                 on:configValueChanged={onValueChange('hitBoxOffsetXLeft', true)}
                 title="hitBoxOffsetXLeft"></ConfigInput>
    <ConfigInput value="{hitBoxOffsetXRightValue}"
                 on:configValueChanged={onValueChange('hitBoxOffsetXRight', true)}
                 title="hitBoxOffsetXRight"></ConfigInput>
    <ConfigInput value="{hitBoxOffsetYTopValue}"
                 on:configValueChanged={onValueChange('hitBoxOffsetYTop', true)} title="hitBoxOffsetYTop"></ConfigInput>
    <ConfigInput value="{hitBoxOffsetYBottomValue}"
                 on:configValueChanged={onValueChange('hitBoxOffsetYBottom', true)}
                 title="hitBoxOffsetYBottom"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">OnTap</p>
    </div>
    <ConfigCheckbox value="{vibrateValue}" title="Vibrate on Click"
                    on:configValueChanged={onValueChange('vibrate', false)}></ConfigCheckbox>

</div>

<style>

    .text-input-combination {
        border-style: dashed;

        display: grid;
        grid-template-columns: 60px 80%;
    }
</style>
